import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQ } from "@/lib/content";

export default function FAQSection() {
  return (
    <section className="section-pad bg-[#EBE9E1]/60" data-testid="home-faq">
      <div className="container-sp grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <div className="overline">Frequently asked</div>
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#0D1B2A] mt-3 leading-tight">
            Before you ask us directly.
          </h2>
          <p className="text-[#4A5568] mt-5">
            If your question isn't here, reach out on WhatsApp. We reply fast
            and honestly — even when the answer is "you don't need us."
          </p>
        </div>
        <div className="lg:col-span-8">
          <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
            {FAQ.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="bg-white rounded-2xl border border-[#EFEEE8] px-6"
              >
                <AccordionTrigger
                  className="font-serif text-left text-lg text-[#0D1B2A] py-5 hover:no-underline"
                  data-testid={`faq-trigger-${i}`}
                >
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-[#4A5568] leading-relaxed pb-6 text-[15px]">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
